import React from 'react';

import withCard from './WithCard';
import Attachment from '../../../Types/Components/Attachment';

const AttachmentCard = (props) => {
  return <Attachment {...props} />
}

export default withCard(AttachmentCard);